import { EventSourcePolyfill, type EventSourcePolyfillInit } from 'event-source-polyfill';

/**
 * EventSourcePolyfill captures `options.headers` once at construction and replays them on
 * every one of its own reconnects, so a reconnected stream keeps sending the access token
 * that was current when the page loaded and starts 401ing as soon as that token expires.
 * Its backoff is also reset by any 200 response, so a server that accepts the request and
 * then drops the stream produces a flat one-reconnect-per-second loop.
 *
 * Closing on the first error makes tRPC treat the failure as fatal (it checks for
 * `readyState === CLOSED`), which hands reconnection to `retryLink` — that re-runs
 * `eventSourceOptions()` and mints a fresh token per attempt.
 */
export class SingleAttemptEventSource extends EventSourcePolyfill {
  constructor(url: string, init?: EventSourcePolyfillInit) {
    super(url, init);
    super.addEventListener('error', () => {
      this.close();
    });
  }
}
